export class FieldsWithinForms {
    DataFieldId: number;
    FieldName: string;
    IsInactive: boolean;
    IsUseForSearch: number;
    Description: string;
    FieldTypeDescription: string;
    ShowOnSummaryGrid: number;
    IsSystemFieldOverride: boolean;
    EditableInApprovedDoc: boolean;
    HideFromPrintDoc: boolean;
    IsSystemField: boolean;
    ISChildExists: boolean;
    IsComplianceCheck: boolean;
    TemplateName: string;
    CreatedDate: Date;
    FieldSize: number;
    FieldType: number;
    FieldFormat: string;
    SpedLookUpMasterID: number;
    IdentityNumber: number;

}

export class FieldsWithinFormsFilterParam {
    TemplateName = '';
}

export class FieldUsedInForm {
    TemplateName: string;
    IsMaster: string;
    Version: number;
    TemplateVersionId: number;

    // Non DTO Field //
    TempVersion: string;
}

export class AccomodationBank {
    MasterId: number;
    MasterDescription: string;
    Code: string;
    Description: string;
    LongDescription: string;
    Active: boolean;
    StateCodeXRef: string;
    IdenticationCodes: number;
    UserId: number;
    DataId: number;
    ParentId: number;
    Category: string;

    // Non DTO
    TemporaryCode: string;
    Checked: boolean;
  DataBankDescription: string;
}

export class FormSetup {
    TemplateVersionId: number;
    TemplateId: number;
    DoumentName: string;
    Comment: string;
    IsPublished: boolean;
    IsActiveVersion: boolean;
    IsStandAlone: boolean;
    PrintPageNumber: boolean;
    IsNewVersionOnLayoutChange: boolean;
    LastModifiedBy: string;
    LastModifiedByUserId: number;
    LastModifiedDate: Date;
    Sequence: number;
    TemplateName: string;
    DocumentDefinition: string;
    IsHTML: string;
    Version: number;
    FieldName: string;

    // Non DTO
    TempVersion: string;
}

export class FormsSetupFilterParam {
    FieldName = '';
}

export class ComplianceRule {
    CollectionId: number;
    CollectionName: string;
    UseForCompliance: boolean;
    TemplateName: string;
    TemplateVersionId: number;
    RuleNumber: string;
    Description: string;
    ErrorMessage: string;
    RuleActive: boolean;
    HardSoftError: string;
    ComplianceId: number;
    VersionStatus: boolean;

}
export class CategoryGrid {
    CategoryId: number;
    CategoryDescription: string;
    Type: boolean;
    DataBankId: number;
    DataBankDescription: string;
    DataParentId: number;
    CombineGoalsAndObjectives: boolean;

    // Non DTO Field //
    TemporaryDescription: string;
    child: CategoryGrid [] = [];
    StatusChecked = false;
}

export class SpedCollection {
    CollectionId: number;
    CollectionName: string;
    CollectionCode: string;
    CollectionSequence: string;
    UseForCompliance: boolean;
    TemplatesCount: number;
    IsAssignedToStudent: boolean;
    SpedCollectionTemplates: SpedCollectionTemplatesItem[] = [];
    SpedCollectionIEPStatus: SpedCollectionToIEPStatus[] = [];
}

export class SpedCollectionTemplatesItem {
    CollectionId: number;
    Version: number;
    IsOptional: boolean;
    IsAllowMultiple: boolean;
    ShowDistrictHeader: boolean;
    TemplateVersionId: number;
    TemplateName: string;
    Sequence: number;
    TemplateCollectionId: number;
    DisplayToParents: boolean;
    DisplayToStudents: boolean;
    IsFormSelected: boolean;
    VersionStatus: boolean;
    IsAssignedToStudent: boolean;
    LastUpdated: Date;

    // Non DTO Field
    TemporaryVersion: string;
    IsEdit: boolean;
    FormAddeded: boolean;
    NewSequence: number;
}

export class SpedCollectionToIEPStatus {
    IEPStatusId: number;
    SpedLookupDataId: number;
    SpedCollectionId: number;
    Description: string;
    CollectionVisible: boolean;
    Sequence: number;
    IsHtml: boolean;
    ScoreReport: boolean;
    UseForCompliance: boolean;
    IsDefault: boolean;
    Completed: boolean;
    ComplianceCheckReq: boolean;
    FreezeEdit: boolean;
    FreezeSystemFields: boolean;
    CollectionName: string;
    CanDeleteIEPStatus: boolean;

    // Non DTO Field //
    StatusChecked = false;
    IsEdited: boolean;
}

export class SpedAvailableForms {
    TemplateVersionId: number;
    SpedTemplateId: number;
    SpedCollectionId: number;
    Version: number;
    SpedTemplateVersionName: string;
    LastModifiedBy: string;
    LastModifiedDate: Date;
    Sequence: number;
    IsHTMLStream: boolean;
}

export class Sequence {
    Id: number;
    SpedCollectionId: number;
    Sequence: number;
}
